module.exports = __webpack_public_path__ + "static-portal/img/map-lh2.9a5b7be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-lh2.png
// module id = agnW
// module chunks = 4